import {Box, Center, Hide, Icon, Show, Spinner, useFoundationTheme} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {forwardRef, ForwardRefRenderFunction, useState} from 'react';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {DocumentPreviewPage} from '../types/DocumentPreviewPage';

interface ZoomImageComponentProps extends RequiredTestIdProps {
  page: DocumentPreviewPage;
}

const zoomImageVariants = cva(
  'relative h-full w-full max-h-none max-w-none select-none overflow-hidden object-contain will-change-transform [-webkit-user-select:none] [-webkit-user-drag:none] [touch-action:none] [-webkit-touch-action:none]'
);

const ZoomImageComponent: ForwardRefRenderFunction<HTMLImageElement, ZoomImageComponentProps> = (
  props,
  ref
) => {
  const theme = useFoundationTheme();
  const [isLoading, setLoading] = useState<boolean>(true);
  const [isError, setError] = useState<boolean>(false);

  return (
    <>
      <Hide when={isError}>
        <img
          ref={ref}
          data-testid={suffixTestId('image', props)}
          draggable={false}
          src={props.page.url}
          alt={`Page number ${props.page.pageNumber}`}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
          loading="lazy"
          className={cn(zoomImageVariants())}
        />
      </Hide>

      <Show when={isError}>
        <Box
          width="100%"
          height="100%"
          backgroundColor={theme.components.Image.emptyFill}
          ratio="4 / 3"
        >
          <Center width="100%" height="100%">
            <Icon color="palettes.neutral.70.100" value="image/photo" size={6} />
          </Center>
        </Box>
      </Show>

      <Show when={isLoading}>
        <Box position="absolute" top={0} left={0} right={0} bottom={0}>
          <Center width="100%" height="100%">
            <Spinner />
          </Center>
        </Box>
      </Show>
    </>
  );
};

export const ZoomImage = forwardRef(ZoomImageComponent);
